import { Flex, Stack, Text, useMediaQuery } from '@chakra-ui/react';
import GetARide from '../Partials/GetARide';

const TripLayout = ({ activeState, children, onChange }) => {
  const [isLargerThan1300] = useMediaQuery('(min-width: 1330px)');

  return (
    <Flex>
      <Stack spacing={0} position={'fixed'}>
        <Text
          cursor={'pointer'}
          p={3}
          m={0}
          _hover={{
            backgroundColor: 'gray.200',
            borderRightRadius: 'md',
          }}
          borderLeft={activeState === 'past' ? '2px brand.900 solid' : null}
          fontWeight={activeState === 'past' ? 'semibold' : 'normal'}
          onClick={() => {
            onChange('past');
          }}
        >
          Past Trips
        </Text>
        <Text
          cursor={'pointer'}
          p={3}
          m={0}
          _hover={{
            backgroundColor: 'gray.200',
            borderRightRadius: 'md',
          }}
          borderLeft={activeState === 'upcoming' ? '2px brand.900 solid' : null}
          fontWeight={activeState === 'upcoming' ? 'semibold' : 'normal'}
          onClick={() => {
            onChange('upcoming');
          }}
        >
          Upcoming Trips
        </Text>
      </Stack>
      {children}
      {isLargerThan1300 && (
        <Stack position={'fixed'} right={'60px'}>
          <GetARide />
        </Stack>
      )}
    </Flex>
  );
};

export default TripLayout;
